import SwitchToClientsAccount from './SwitchToClientsAccount';
import { connect } from 'react-redux';
import {
  dashboardViewActions,
  dashboardViewErrorSel,
  dashboardViewIsPendingSel
} from 'src/store/modules/dashboardview';
import {
  userActions,
  accountsSel,
  accountsPaginationSel
} from 'src/store/modules/user';
import {
  isLoggedInSel,
  shouldSelectAccountSel,
  shouldVerifySel,
  signInActions,
  accountHasChangedSel
} from 'src/store/modules/signin';

const mapStateToProps = (state: any) => {
  return {
    isLoading: dashboardViewIsPendingSel(state),
    hasError: dashboardViewErrorSel(state).hasFailed,
    accounts: accountsSel(state),
    accountsPagination: accountsPaginationSel(state),
    shouldSelectAccount: shouldSelectAccountSel(state),
    shouldVerify: shouldVerifySel(state),
    isLoggedIn: isLoggedInSel(state),
    accountHasChanged: accountHasChangedSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onClearError: () => dispatch(dashboardViewActions.setError()),
  getAccounts: (search: string, page?: number, size?: number) =>
    dispatch(userActions.searchUserAccounts(search, page, size)),
  changeActiveAccount: (newAccountId: string, clientIdentity: string) =>
    dispatch(signInActions.changeActiveAccount(newAccountId, clientIdentity)),
  changeActiveAccountFlag: (flag: boolean) =>
    dispatch(signInActions.activeAccountHasChanged(flag))
});

export const pureComponent = SwitchToClientsAccount;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitchToClientsAccount);

interface IDispatchFromProps {
  onClearError(): void;
  getAccounts(search: string, page?: number, size?: number): void;
  changeActiveAccount(newAccountId: string, clientIdentity: string): void;
  changeActiveAccountFlag(flag: boolean): void;
}
